//
// ResultVariable.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../BIRDModel";
import "../dataDefinition/DataItemOrPromptDefinition";
import "./ResultColumn";
import "@sas-dvr/ltjs-commons/models/data/sorting/SortPreprocessing";
import "./sorting/CustomSort";
import "./Presentation";
import "../dataDefinition/common/VariableUsage";
import "./RollupPurpose";

var ResultVariable = createModule("BIRD::ResultVariable", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel"], EventDispatcher, [
    ,
    {
        dataItem: 1,
        filterable: 2,
        xref: 7,
        usage: 4,
        column: 1,
        label: 7,
        varname: 7,
        presentations: [1],
        distinctCount: 4,
        sortOn: 4,
        rollupPurpose: 4,
        customSort: 1,
        regionMapProvider: 7,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default ResultVariable;
